import { Radio } from 'antd';
import styled from 'styled-components';

export const RadioGroupWrapper = styled(Radio.Group)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
